import { render, staticRenderFns } from "./WorkspaceStorageCard.vue?vue&type=template&id=7eadee8e&scoped=true&"
import script from "./WorkspaceStorageCard.vue?vue&type=script&lang=js&"
export * from "./WorkspaceStorageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eadee8e",
  null
  
)

export default component.exports